import { createContext, useContext, useState, useEffect } from 'react';
import { getSession, signIn as apiSignIn, signOut as apiSignOut } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSession()
      .then((session) => { if (session?.user) setUser(session.user); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const u = await apiSignIn(email, password);
      setUser(u);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: err.message || 'Email ou mot de passe incorrect.' };
    }
  };

  const logout = async () => {
    await apiSignOut().catch(() => {});
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => useContext(AuthContext);
